"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        label: "器件物料号",
        name: "suyuanqijianwuliaobianma",
    },
    {
        label: "供应商批次",
        name: "pici",
    },
    {
        label: "器件名称",
        name: "suyuanqijianwuliaomingcheng",
    },
    {
        label: "所属桩SN码",
        name: "chengpinsnma",
        type: "select",
        paramKey: "chengpinsnmaKeywords",
    },
    {
        label: "器件SN",
        name: "suyuanqijiansn",
        type: "select",
    },
];
